export default __webpack_public_path__ + "static/burjalarab-2bc06cf80e78e8155a936d0669dd3cd0.webp";